import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Button, NavDropdown } from 'react-bootstrap';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import brandLogo from '../../assets/icons/Agilisium new logo .png';
import { useSelector } from 'react-redux';
import FlipHubSearchBar from './FlipHubSearchBar';
import TownSquareSearchBar from '../townsquare/TownSquareSearchBar';
import BraingymSearchBar from '../braingym/BrainGymSearchBar';
import KnowHowNowSearchBar from '../knowhownow/KnowHowNowSearchBar';
import ProPointSearchBar from '../propoint/ProPointSearchBar';
import KfmSearchBar from '../kfm/KfmSearchBar';


function FlipHubNavBar() {
  const [show, setShow] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [activeLink, setActiveLink] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();
  const authState = useSelector((state) => state.authUser);
  // const role_id = authState?.profile?.role?.role_id;
  const userRoles = authState?.userRoles || [];
  const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);

  useEffect(() => {
    if (location.pathname === '/flipHub') {
      setActiveLink('home');
    }
  }, [location]);

  const handleClose = (link) => {
    setShow(false);
    setActiveLink(link);
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="bg-body-tertiary p-0"
        expanded={show}
        style={{ position: 'fixed', width: '100%', zIndex: '999' }}
      >
        <Container
          fluid
          style={{ background: '#FFF' }}
          className="bg-white p-1 border border-gray-400"
        >
          {/* Brand Logo */}
          <Navbar.Brand
            className="brand"
            onClick={() => {
              navigate('/flipHub');
              handleClose('home');
            }}
          >
            <img
              src={brandLogo}
              alt="brand"
              style={{
                top: '19px',
                left: '48px',
                height: '58px',
                opacity: '1',
              }}
            />
          </Navbar.Brand>

          {/* Mobile Toggle */}
          <Navbar.Toggle
            aria-controls="flipHubNavbarScroll"
            onClick={() => setShow(!show)}
          />

          {/* Navbar Links */}
          <Navbar.Collapse id="flipHubNavbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <Nav.Link
                as={NavLink}
                to="/tlfHub"
                className={`px-4 navHeader ${activeLink === 'home' ? 'active' : ''}`}
                onClick={() => handleClose('home')}
              >
                Home
              </Nav.Link>
              {/* <Nav.Link
                as={NavLink}
                to="/townSquare"
                className={`px-4 navHeader ${activeLink === 'townSquare' ? 'active' : ''}`}
                onClick={() => handleClose('townSquare')}
              >
                Town Square
              </Nav.Link> */}
              {(hasRole(6) || hasRole(15)) && <NavDropdown
                title={hasRole(6) ? "Super Admin" : "Admin"}
                id="navbarScrollingDropdown"
                className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/manageFlipEpisodes"
                  className="bg-transparent menulink"
                  onClick={() => handleClose('admin')}

                >
                  Manage FLIP Episodes
                </NavDropdown.Item>
                <NavDropdown.Divider className='divider' />
                <NavDropdown.Item
                  as={NavLink}
                  to="/manageTownSquareEpisodes"
                  className="bg-transparent menulink"
                  onClick={() => handleClose('admin')}

                >
                  Manage Town Square Episodes
                </NavDropdown.Item>
                <NavDropdown.Divider className='divider' />
                <NavDropdown.Item
                  as={NavLink}
                  to="/manageBrainGymEpisodes"
                  className="bg-transparent menulink"
                  onClick={() => handleClose('admin')}

                >
                  Manage Brain Gym Episodes
                </NavDropdown.Item>
                <NavDropdown.Divider className='divider' />
                <NavDropdown.Item
                  as={NavLink}
                  to="/manageKnowHowNowEpisodes"
                  className="bg-transparent menulink"
                  onClick={() => handleClose('admin')}

                >
                  Manage Know How Now Episodes
                </NavDropdown.Item>
                <NavDropdown.Divider className='divider' />
                <NavDropdown.Item
                  as={NavLink}
                  to="/manageProPointEpisodes"
                  className="bg-transparent menulink"
                  onClick={() => handleClose('admin')}

                >
                  Manage Pro Point Episodes
                </NavDropdown.Item>
                <NavDropdown.Divider className='divider' />
                <NavDropdown.Item
                  as={NavLink}
                  to="/manageKfmEpisodes"
                  className="bg-transparent menulink"
                  onClick={() => handleClose('admin')}

                >
                  Manage KFM Episodes
                </NavDropdown.Item>

              </NavDropdown>}

            </Nav>
          </Navbar.Collapse>
          <Navbar.Text>
            {location.pathname.startsWith('/flipHub') && <FlipHubSearchBar />}
            {location.pathname.startsWith('/townSquare') && <TownSquareSearchBar />}
            {location.pathname.startsWith('/brainGym') && <BraingymSearchBar />}
            {location.pathname.startsWith('/knowHowNow') && <KnowHowNowSearchBar />}
            {location.pathname.startsWith('/proPoint') && <ProPointSearchBar />}
            {location.pathname.startsWith('/kfm') && <KfmSearchBar />}
          </Navbar.Text>

          {/* Button to Go Back */}
          <Navbar.Brand className="brand" onClick={() => navigate('/')}>
            <Button className="backtohomebtn">Go to Agilisium Page</Button>
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
}

export default FlipHubNavBar;
